import { FileUploader } from '@partful/features/file-uploader/FileUploader';
import { useUploadFile } from '@partful/shared/lib/hooks/useUploadFile';
import { useCallback } from 'react';
import { useCreatePartCategoriesIngest } from '../lib/hooks/useCreatePartCategoriesIngest';
import { useCreatePartCategoriesJob } from '../lib/hooks/useCreatePartCategoriesJob';
import { type PartsCategoriesFormSchema } from '../lib/PartsCategoriesFormSchema';

interface UploadPartsCategoriesFormProps {
  accountId: string;
  configurationPID: string;
}

export function UploadPartsCategoriesForm({ accountId, configurationPID }: UploadPartsCategoriesFormProps) {
  const { mutateAsync: uploadFile } = useUploadFile();
  const { mutateAsync: createPartCategoriesJob } = useCreatePartCategoriesJob();
  const { mutateAsync: createPartCategoriesIngest } = useCreatePartCategoriesIngest();

  const onSubmit = useCallback(
    async (data: PartsCategoriesFormSchema): Promise<void> => {
      const { file } = data;

      const { uploadURL, runID } = await createPartCategoriesJob({ configurationPID, accountId });

      await uploadFile({ file, uploadURL });
      await createPartCategoriesIngest({ accountId, runID });
    },
    [accountId, configurationPID, createPartCategoriesJob, createPartCategoriesIngest, uploadFile]
  );

  return <FileUploader submitHandler={onSubmit} />;
}
